<template>
  <div>
    <label v-if="label" class="mr-1 text-size-14 text-mild">{{ label }}</label>
    <AppLabel variant="red">{{ appLabelText }}</AppLabel>
    <FormCheckboxGroupItems
      :options="options"
      :checked-items="value"
      :name="name"
      :text-field="textField"
      :value-field="valueField"
      :variant="variant"
      @input="onInput"
    />
    <FormInvalidFeedback
      v-if="validationState"
      :validation-state="validationState"
      :state="false"
    />
  </div>
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-facing-decorator";
import AppLabel from "@/components/atoms/input/AppLabel.vue";
import FormCheckboxGroupItems from "@/components/molecules/form/FormCheckboxGroupItems.vue";
import FormInvalidFeedback from "@/components/atoms/other/FormInvalidFeedback.vue";
import { FormOption } from "@/types/form/FormOption";

@Component({
  components: {
    AppLabel,
    FormCheckboxGroupItems,
    FormInvalidFeedback
  }
})
export default class FormCheckboxGroup extends Vue {
  @Prop({
    type: Array,
    required: true,
    default: []
  })
  value!: string[];

  @Prop({
    type: Array,
    required: true,
    default: []
  })
  options!: FormOption[];

  @Prop({
    type: String,
    default: ""
  })
  label!: string;

  @Prop({
    type: String,
    default: ""
  })
  appLabelText!: string;

  @Prop({
    type: String,
    default: ""
  })
  name!: string;

  @Prop({
    type: String,
    default: ""
  })
  textField!: string;

  @Prop({
    type: String,
    default: ""
  })
  valueField!: string;

  @Prop({
    type: Object,
    default: null
  })
  validationState!: object;

  @Prop({
    type: String,
    default: ""
  })
  variant!: string;

  onInput(v: string[]) {
    this.$emit("input", v);
    // 値変更によるイベントをトリガーさせたいので、change イベントも emit する
    this.$emit("change", v);
  }
}
</script>
